

import React from "react";
import { Link } from "react-router-dom";
import instagram from "../../../src/assets/Images/instagram.png";
import facebook from "../../../src/assets/Images/facebook.png";
import whatsapp from "../../../src/assets/Images/whatsapp.png";
import twitter from "../../../src/assets/Images/twitter.png";
import NavBarImg from "../../assets/Logo/logo1.png";
import { MdCopyright } from "react-icons/md";

const Footer = () => {
  return (
    <div className="bg-pure-greys-400 py-8 px-4 md:px-8 lg:px-20">
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="mb-6 md:mb-0">
          <Link to="/">
            <img src={NavBarImg} alt="Health Ease" className="w-24 md:w-32 lg:w-48" />
          </Link>
        </div>
        <div className="mx-auto">
          <ul className="flex justify-center items-center md:justify-start">
            <li className="mx-2 my-1 md:mx-4 md:my-2">
              <Link to="/" className="text-white hover:text-pink-500">Home</Link>
            </li>
            <li className="mx-2 my-1 md:mx-4 md:my-2">
              <Link to="/about" className="text-white hover:text-pink-500">About Us</Link>
            </li>
            <li className="mx-2 my-1 md:mx-4 md:my-2">
              <Link to="/contact" className="text-white hover:text-pink-500">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex justify-center mx-auto  mt-6">
        <Link to="https://www.instagram.com" className="mx-2 hover:scale-110 transition-transform duration-200">
          <img src={instagram} alt="Instagram" width={30} height={30} />
        </Link>
        <Link to="https://www.facebook.com" className="mx-2 hover:scale-110 transition-transform duration-200">
          <img src={facebook} alt="Facebook" width={30} height={30} />
        </Link>
        <Link to="https://www.twitter.com" className="mx-2 hover:scale-110 transition-transform duration-200">
          <img src={twitter} alt="Twitter" width={30} height={30} />
        </Link>
        <Link to="https://www.whatsapp.com" className="mx-2 hover:scale-110 transition-transform duration-200">
          <img src={whatsapp} alt="WhatsApp" width={30} height={30} />
        </Link>
      </div>
      <div className="flex justify-center items-center text-white mt-6 mx-auto">
        <span><MdCopyright /></span>
        <span className="">2024 Course Catalyst | All Rights Reserved</span>
      </div>
    </div>
  );
};

export default Footer;
